






import { Vue, Component, Prop } from 'vue-property-decorator';

import FloatingField from '@/components/form/FloatingField.vue';
import BaseInput from '@/components/input/BaseInput.vue';

@Component({
    name: 'FloatingInput',
    components: {
        FloatingField,
        BaseInput,
    }
})
export default class FloatingInput extends Vue {
    // TODO: upgrade vue-property-decorator and replace modelWrapper get/set with VModel directive
    @Prop({ type: [String, Number] }) readonly  value!: string | number
    @Prop({ type: String, required: true }) readonly label!: string

    get modelWrapper() { 
        return this.value;
    }

    set modelWrapper(value) {
        this.$emit('input', value);
    }

    onBlur() {
        this.$emit('blur');
    }
}
